import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/_services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Operations } from 'src/app/_models/Operations/Operations';
import { GetHostsModelResponse, HostModelRequest, UpdateHostModelRequest } from 'src/app/_models/Host/HostModel';
import { CompanyService } from 'src/app/company.service';

@Component({
  selector: 'app-host-dialog',
  templateUrl: './host-dialog.component.html',
  styleUrls: ['./host-dialog.component.scss']
})
export class HostDialogComponent implements OnInit {

  hostForm: UntypedFormGroup = new UntypedFormGroup({})
  activeStep: number = 1;
  typesIds: number[] = new Array();

  childComponentsDataLoaded: boolean = false;
  // venueID: string = '';
  venueIDs: string[] = [];
  companyID: string = '';

  loading: boolean = false;

  operationType: Operations;

  host: GetHostsModelResponse = {};

  constructor(
    private dialogRef: MatDialogRef<HostDialogComponent>,
    private apiService: ApiService,
    private companyService: CompanyService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.operationType = data.operation;
    this.host = data.host;
    this.getCompanyId();
  }

  ngOnInit(): void {
    this.initForm();
    if(this.operationType==Operations.Edit){
      this.disableFormFields();
    }
  }

  save() {
    this.loading = true;
    let hostModel: HostModelRequest = {};
    hostModel.firstName = this.hostForm.controls['hostFirstName'].value;
    hostModel.lastName = this.hostForm.controls['hostLastName'].value;
    hostModel.email = this.hostForm.controls['email'].value;
    hostModel.phone = this.hostForm.controls['phone'].value;
    hostModel.companyId = this.companyID;
    hostModel.venueIds = this.venueIDs;

    switch (this.operationType) {
      case Operations.Add: {
        this.apiService.createHost(hostModel).subscribe(() => {
          this.hostForm.reset();
          this.loading = false;
          this.dialogRef.close(false);
          this.snackBar.open('The Host user is successfully created!', 'Cancel', {
            duration: 3000
          });
        }, (error) => {
          this.loading = false;
        })
        break;
      }
      case Operations.Edit: {
        let updateHostModel: UpdateHostModelRequest = {};
        updateHostModel.hostId = this.host.id;
        updateHostModel.firstName = hostModel.firstName;
        updateHostModel.lastName = hostModel.lastName;
        updateHostModel.email = hostModel.email;
        updateHostModel.phone = hostModel.phone;
        updateHostModel.venueIds = hostModel.venueIds;
        this.apiService.updateeHost(updateHostModel).subscribe(() => {
          this.hostForm.reset();
          this.loading = false;
          this.dialogRef.close(false);
          this.snackBar.open('The Host user is successfully updated!', 'Cancel', {
            duration: 3000
          });
        }, (error) => {
          this.loading = false;
        });
        break;
      }
      case Operations.Delete: {
        this.hostForm.reset();
        this.loading = false;
        this.dialogRef.close(false);
        this.snackBar.open('Host deactivated!', 'Cancel', {
          duration: 3000
        });
      }
    }
  }

  close() {
    this.hostForm.reset();
    this.dialogRef.close(true);
  }

  private initForm() {
    let hosts = new UntypedFormArray([]);
    this.hostForm = new UntypedFormGroup({
      hostFirstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      hostLastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      phone: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50),
      Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')]),
      hosts: hosts
    });
    if (this.operationType == Operations.Edit) {
      this.loading = true;
      this.hostForm.patchValue({ hostFirstName: this.host.firstName });
      this.hostForm.patchValue({ hostLastName: this.host.lastName });
      this.hostForm.patchValue({ email: this.host.email });
      this.hostForm.patchValue({ phone: this.host.phone });
      if (this.host.venueIds) {
        this.venueIDs = this.host.venueIds;
      }
      this.loading = false;
    }
  }

  disableFormFields(){
    this.hostForm.controls['email'].disable();
  }

  get hostFormControls() {
    return this.hostForm.controls;
  }

  getCompanyId() {
    this.companyID = this.companyService.getCompanyId()
  }

  // selectedVenue(item: any){
  //   if(item != null){
  //     this.venueID = item.id;
  //   }
  //   else{
  //     this.venueID = "";
  //   }
  // }

  shareCheckedList(item: string[]) {
    this.venueIDs = item;
  }

}
